<div *ngIf="renderUserPopover" fxLayout="row">
	<div *ngIf="isEnabled" fxFlex>
		<mat-form-field
			#popoverTrigger="mtxPopoverTrigger"
			(click)="$event.stopPropagation()"
			*ngIf="isEnabled"
			[mtxPopoverTriggerFor]="usersPopover"
			class="custom-form-field {{ customFormFieldClass }}"
			floatLabel="never"
			fxFlex
			mtxPopoverTriggerOn="click"
		>
			<mat-label class="primary-text">{{ placeholder }}</mat-label>
			<input matInput readonly="true" />
			<mat-icon class="vertical-align-middle" matSuffix>keyboard_arrow_down</mat-icon>
		</mat-form-field>

		<mtx-popover #usersPopover="mtxPopover" [closeOnPanelClick]="false">
			<mat-card class="p-0 primary-border">
				<mat-card-content class="users-dropdown font-size-14">
					<div class="padding-0-5" fxLayout="row">
						<mat-form-field fxFlex>
							<input
								[(ngModel)]="searchText"
								autocomplete="off"
								matInput
								placeholder="Type to filter"
							/>
						</mat-form-field>
					</div>
					<div *ngIf="showAssignMe" class="padding-0-5 py-0" fxLayout="row">
						<div (click)="setCurrentUser()" class="link" fxFlex fxLayoutAlign="end center">
							{{ assignText }}
						</div>
					</div>
					<div
						(click)="user.selected = !user.selected; userClicked(user)"
						*ngFor="let user of usersList | search : 'name' : searchText"
						class="padding-0-5 user-row"
						fxLayout="row"
					>
						<div fxFlex="15" fxLayoutAlign="start center">
							<mat-checkbox
								(change)="userClicked(user)"
								(click)="$event.stopPropagation()"
								[(ngModel)]="user.selected"
								[color]="'primary'"
							>
							</mat-checkbox>
						</div>
						<div
							class="primary-text truncate_text"
							fxFlex
							fxLayoutAlign="start center"
							[appTruncateTooltip]="user.name"
						>
							{{ user.name }} - {{ user.email }}
						</div>
					</div>

					<div *ngIf="(usersList | search : 'name' : searchText)?.length === 0" class="padding-0-5">
						<div fxFlex fxLayoutAlign="center center">No matching user found</div>
					</div>
				</mat-card-content>
			</mat-card>
		</mtx-popover>
	</div>

	<div *ngIf="!isEnabled" fxFlex>
		<mat-form-field
			(click)="$event.stopPropagation()"
			*ngIf="!isEnabled"
			class="custom-form-field"
			floatLabel="never"
			fxFlex
			matTooltip="Only the project owner can assign the user"
			matTooltipClass="custom-tooltip"
		>
			<mat-label class="secondary-text-color">{{ placeholder }}</mat-label>
			<input matInput readonly="true" />
			<mat-icon class="vertical-align-middle secondary-text-color" matSuffix
				>keyboard_arrow_down
			</mat-icon>
		</mat-form-field>
	</div>

	<div *ngIf="showAssignMeOnRight" fxFlex class="m-t-0-7">
		<span (click)="setCurrentUser()" class="link p-l-0-5 font-size-14">
			{{ assignText }}
		</span>
	</div>
</div>

<div *ngIf="showAssignMeBelowInput" fxLayout="row">
	<div (click)="setCurrentUser()" class="link m-t-1">
		{{ assignText }}
	</div>
</div>
